// extracted by mini-css-extract-plugin
export default {"loader":"spinner_loader__ywZHh","load5":"spinner_load5__eJElv"};